import { render, staticRenderFns } from "./pointChangeList.vue?vue&type=template&id=7ff3aa24&scoped=true"
import script from "./pointChangeList.vue?vue&type=script&lang=js"
export * from "./pointChangeList.vue?vue&type=script&lang=js"
import style0 from "./pointChangeList.vue?vue&type=style&index=0&id=7ff3aa24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff3aa24",
  null
  
)

export default component.exports